(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/tabs/views/tab-list_partial.js') >= 0) return;  svs.modules.push('/components/components/tabs/views/tab-list_partial.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.tabs=_cmps.tabs||{};
_cmps.tabs.partials=_cmps.tabs.partials||{};
svs.components.tabs.partials.tab_list = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"js-tabs-tabs tabs-tabs slider-container\">\n  <div class=\"js-slider-wrapper slider-wrapper tabs-overflow-x\" style=\"width: 100%; text-align: center;\">\n    "
    + container.escapeExpression(((helper = (helper = helpers.content || (depth0 != null ? depth0.content : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data}) : helper)))
    + "\n  </div>\n</div>";
},"useData":true});
Handlebars.partials['components-tabs-tab_list'] = svs.components.tabs.partials.tab_list;
})(svs, Handlebars);

 })(window);